import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Checkbox from "@amzn/meridian/checkbox";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import { FieldArray } from "formik";
import React from "react";
import { Space } from "../space/Space";
import { unitTypes } from "./definitions";

const SiteImprovementDetails = improvementDetailsField => {
    const {
        fieldProps: {
            field: { value: improvementDetails },
            form: currentForm,
        },
    } = improvementDetailsField;

    return (
        <FieldArray
            name={"siteImprovementDetails"}
            render={arrayHelpers => (
                <React.Fragment>
                    {improvementDetails
                        ?.sort(
                            (a, b) =>
                                a.siteImprovementType.toUpperCase() >
                                b.siteImprovementType.toUpperCase()
                        )
                        .map((currentImprovement, index) => {
                            return (
                                <Box>
                                    <Row
                                        widths={["grid-4", "grid-3", "stretch"]}
                                        spacing={"200"}
                                        alignmentVertical={"stretch"}
                                    >
                                        <Column alignmentVertical={"top"}>
                                            {currentImprovement.siteImprovementType === "Other" ? (
                                                <Input
                                                    value={currentImprovement.siteImprovementName}
                                                    label={"Other improvement name"}
                                                    size={"small"}
                                                    onChange={newQuantity => {
                                                        currentForm.setFieldValue(
                                                            `siteImprovementDetails[${index}].siteImprovementName`,
                                                            newQuantity
                                                        );
                                                    }}
                                                    error={
                                                        currentForm?.errors?.siteImprovementDetails
                                                            ? currentForm?.errors
                                                                  ?.siteImprovementDetails[index]
                                                                  ?.siteImprovementName
                                                            : null
                                                    }
                                                    errorMessage={
                                                        currentForm?.errors?.siteImprovementDetails
                                                            ? currentForm?.errors
                                                                  ?.siteImprovementDetails[index]
                                                                  ?.siteImprovementName
                                                            : null
                                                    }
                                                />
                                            ) : (
                                                <Checkbox
                                                    checked={currentImprovement.isApplicable}
                                                    onChange={() => {
                                                        currentForm.setFieldValue(
                                                            `siteImprovementDetails[${index}].isApplicable`,
                                                            !currentImprovement.isApplicable
                                                        );
                                                    }}
                                                    children={
                                                        currentImprovement.siteImprovementName
                                                    }
                                                />
                                            )}
                                        </Column>

                                        {currentImprovement.isApplicable && (
                                            <Column alignmentVertical={"top"}>
                                                <Input
                                                    value={currentImprovement.quantity || ""}
                                                    label={
                                                        currentImprovement.siteImprovementType ===
                                                        "Other"
                                                            ? "Cost"
                                                            : null
                                                    }
                                                    inputMode={"numeric"}
                                                    suffix={
                                                        unitTypes.get(
                                                            currentImprovement.quantityUnit
                                                        ).displayType
                                                    }
                                                    type="number"
                                                    disabled={
                                                        currentImprovement.siteImprovementType ===
                                                        "Curbs, drainage, lighting"
                                                    }
                                                    size={"small"}
                                                    onChange={newQuantity => {
                                                        currentForm.setFieldValue(
                                                            `siteImprovementDetails[${index}].quantity`,
                                                            parseFloat(newQuantity)
                                                        );
                                                    }}
                                                    error={
                                                        currentForm?.errors?.siteImprovementDetails
                                                            ? currentForm?.errors
                                                                  ?.siteImprovementDetails[index]
                                                                  ?.quantity
                                                            : null
                                                    }
                                                    errorMessage={
                                                        currentForm?.errors?.siteImprovementDetails
                                                            ? currentForm?.errors
                                                                  ?.siteImprovementDetails[index]
                                                                  ?.quantity
                                                            : null
                                                    }
                                                />
                                            </Column>
                                        )}
                                        <Column alignmentVertical={"top"}>
                                            <Box height={"12px"} />
                                            {currentImprovement.siteImprovementType === "Other" && (
                                                <Button
                                                    type={"icon"}
                                                    size={"small"}
                                                    onClick={() => {
                                                        arrayHelpers.remove(index);
                                                    }}
                                                >
                                                    <Icon tokens={trashTokens}></Icon>
                                                </Button>
                                            )}
                                        </Column>
                                    </Row>
                                    <Space size={"xxxs"} />
                                </Box>
                            );
                        })}
                    <Space size={"s"} />
                    <Button
                        type={"tertiary"}
                        size={"small"}
                        onClick={() => {
                            arrayHelpers.push({
                                siteImprovementName: null,
                                siteImprovementType: "Other",
                                isApplicable: true,
                                quantity: null,
                                quantityUnit: "USD",
                            });
                        }}
                    >
                        Add
                    </Button>
                </React.Fragment>
            )}
        />
    );
};

export default SiteImprovementDetails;
